import React from 'react';

import Checkbox from './Checkbox';
import { moveItemUp, moveItemDown } from '../utils';

const ItemActions = ({
  dispatch,
  first,
  identifier,
  item,
  last,
  onChange,
  type,
  handleRequestUpdate,
  isDisabled,
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center">
        <Checkbox
          size="2.25rem"
          checked={item.enable}
          onChange={(v) => {
            onChange(`${identifier}enable`, v);
          }}
          label="Show on CV"
        />
      </div>
      {/* 
      {handleRequestUpdate && (
        <button
          type="button"
          className="rounded btn_request_update"
          style={{ textWrap: 'nowrap', whiteSpace: 'nowrap' }}
          onClick={handleRequestUpdate}
        >
          Request Update
        </button>
      )} */}

      {!isDisabled && (
        <div className="flex">
          {!first && (
            <button
              type="button"
              onClick={() => moveItemUp(dispatch, type, item)}
              className={`bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium py-2 px-4 rounded ${
                last ? '' : 'mr-2'
              }`}
            >
              <div className="flex items-center">
                <i className="material-icons font-bold text-base">arrow_upward</i>
              </div>
            </button>
          )}

          {!last && (
            <button
              type="button"
              onClick={() => moveItemDown(dispatch, type, item)}
              className="bg-gray-600 hover:bg-gray-700 text-white text-sm font-medium py-2 px-4 rounded"
            >
              <div className="flex items-center">
                <i className="material-icons font-bold text-base">arrow_downward</i>
              </div>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemActions;
